<template>
    <el-dialog :title="(formData.edit? $t('Update request'):$t('Create Case'))" :visible.sync="dialogFormVisible" :before-close="handleClose" @open="handleOpen('formData')" width="40%">
        <el-form label-position="top" :model="formData" ref="formData" :rules="rules">
             <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <el-alert style="margin-bottom: 10px;" effect="dark" :title="$t('Fields with a ! Can be viewed by the board members. Please anonymise text for data protection reasons.')" type="warning" show-icon></el-alert>
                </el-col>
            <input type="hidden" v-model="formData.fachstellen_slug" v-if="$store.state.config.user.fachstellen_slug || fachstellen_slug">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-else>
                <el-row>
                    <el-col :xs="24" :sm="24" :md="10" :lg="8" :xl="8">
                        <el-form-item :label="$t('Fachstellen type')" prop="fachstellen_type">
                            <el-select v-model="formData.fachstellen_type" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)" :placeholder="$t('Fachstellen type')" @change="getAllFachstellen" filterable>
                                <el-option v-for="(item, key) in fachstellenTypes.data" :label="item" :key="key" :value="key"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="14" :lg="16" :xl="16">
                        <el-form-item :label="$t('Fachstellen')" prop="fachstellen_slug">
                            <el-select v-model="formData.fachstellen_slug" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)" :placeholder="$t('Fachstellen')" @change="getAllPatenkinder" filterable>
                                <el-option v-for="(item) in filterData.fachstellenList.data" :label="item.display_name" :key="item.slug" :value="item.slug"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item :label="$t('Godchild')" prop="patenkinder_slug">
                    <el-select v-model="formData.patenkinder_slug" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)" :placeholder="$t('Godchild')" filterable>
                        <el-option v-for="(item) in filterData.patenkinderList.data" :label="item.display_name" :key="item.slug" :value="item.slug"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" >
                <el-form-item :label="$t('Case Title')" class="exclamation-mark" prop="case_title">
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 40}" v-model="formData.case_title" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item :label="$t('Description of the application')" class="exclamation-mark" prop="description">
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 40}" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)" v-model="formData.description"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <h3>{{ $t('Criteria for supporting the godchild') }}:</h3>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item :label="'1.'+$t('It can be ensured that the support lines benefit only the child.')" class="exclamation-mark is-required">
                    <br />
                    <el-radio-group v-model="formData.q_ans_1" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)">
                        <el-radio label="yes">{{ $t('Yes') }}</el-radio>
                        <el-radio label="no">{{ $t('No') }}</el-radio>
                    </el-radio-group>
                    <br />
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 40}" v-model="formData.ans_1_description" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item :label="'2.'+$t('The payment is made via a specialist office or with a direct payment slip (eg bill music school).')" class="exclamation-mark is-required">
                    <br />
                    <el-radio-group v-model="formData.q_ans_2" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)">
                        <el-radio label="yes">{{ $t('Yes') }}</el-radio>
                        <el-radio label="no">{{ $t('No') }}</el-radio>
                    </el-radio-group>
                    <br />
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 40}" v-model="formData.ans_2_description" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item :label="'3.'+$t('It is ensured that no other organization (public sector, insurance, etc.) would have to pay for the neediness?')" class="exclamation-mark is-required">
                    <br />
                    <el-radio-group v-model="formData.q_ans_3" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)">
                        <el-radio label="yes">{{ $t('Yes') }}</el-radio>
                        <el-radio label="no">{{ $t('No') }}</el-radio>
                    </el-radio-group>
                    <br />
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 40}" v-model="formData.ans_3_description" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item :label="'4.'+$t('The support service promotes the integration of the child into its environment / society (eg supporting activities with other children).')" class="exclamation-mark is-required">
                    <br />
                    <el-radio-group v-model="formData.q_ans_4" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)">
                        <el-radio label="yes">{{ $t('Yes') }}</el-radio>
                        <el-radio label="no">{{ $t('No') }}</el-radio>
                    </el-radio-group>
                    <br />
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 40}" v-model="formData.ans_4_description" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item :label="'5.'+$t('Payment instructions:')" class="exclamation-mark is-required">
                    <br>
                    {{ $t('Please enter the recipient\'s IBAN and account details') }}
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 40}" v-model="formData.ans_5_description" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item :label="$t('Remarks of the Office')" prop="remark">
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 40}" v-model="formData.remark" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending') ? true : ($store.state.config.user.role_slug == 'fachstellen' ? true :false) : ($store.state.config.user.role_slug == 'fachstellen' ? true :false))"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="px-10 card-row" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)">
                    <el-upload :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)"
                        class="upload-demo"
                        :on-change="handleChange"
                        ref="elFileUpload"
                        action=""
                        :auto-upload="false"
                        :on-remove="handleRemove"
                        :before-upload="beforeUpload"
                        
                        :show-file-list="fileUpload.showFileList" multiple>
                        <!-- v-if="!formData.edit" -->
                        <el-button slot="trigger" size="small" type="primary" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)">{{ $t('select file') }}</el-button>
                        <div slot="tip" class="el-upload__tip" v-if="formData['payment_slip'].length=== 0">{{ $t('or upload an invoice with a payment slip.') }}</div>                       
                    </el-upload>
                    <div v-if="(formData.edit && formData.payment_slip_doc.length > 0)" style="display: inline-block;width: 100%;">
                    <el-row v-for="(images, i) in formData.payment_slip_doc" :key="images.id" style="margin-bottom: 5px;">
                        <a style="text-decoration:underline"  target="_blank" :href="images.payment_slip" v-if=" (images.payment_slip !== null && images.payment_slip !== '') && fileUpload.fileNotChanged">{{ images.payment_slip_name.substring(images.payment_slip_name.indexOf('-')+1) }}</a>
                        <!-- <el-button type="primary" size="small" v-if=" (images.payment_slip !== null && images.payment_slip !== '') && fileUpload.fileNotChanged"><a class="view-file" target="_blank" :href="images.payment_slip">{{ $t('view file') }}</a></el-button> -->
                        <el-button type="" size="mini" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)" @click="removeUploadedFile(i)" v-if="images.payment_slip !== null && images.payment_slip !== '' && formData.edit"> <i class="el-icon-close"></i></el-button>
                        <!-- <i class="el-icon-close" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)" @click="removeUploadedFile(i)" v-if="images.payment_slip !== null && images.payment_slip !== '' && formData.edit"></i> -->
                    </el-row>
                    </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-row>
                    <h3 style="float:left;">{{ $t('Support requested') }}:</h3>
                    <el-tooltip class="item" effect="dark" :content="$t('Create')" placement="left-end">
                        <el-button @click="handleCreate();" class="is-circle el-button--mini" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)" circle>
                            <i aria-hidden="true" class="el-icon-plus"></i>
                        </el-button>
                    </el-tooltip>
                </el-row>
                <el-row v-for="(item,i) in formData.additions" :key="item.id">
                    <el-col :xs="12" :sm="8" :md="8" :lg="8" :xl="8">
                        <el-form-item :label="$t('What')" :prop="'additions.'+i+'.reason'" :rules="[{ required: true, message: $t('This field is required'), trigger: ['blur','change']}]">
                            <el-input v-model="formData.additions[i].reason" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="7" :md="7" :lg="7" :xl="7">
                        <el-form-item :label="$t('Cost')" :prop="'additions.'+i+'.cost'" :rules="[{ required: true, message: $t('This field is required'), trigger: ['blur','change']}]">
                                <div class="el-input el-input-group el-input-group--prepend">
                                    <div class="el-input-group__prepend">{{ $store.state.config.generalSettings.currency_code }}</div>
                                    <input :maxlength="10" v-model="formData.additions[i].cost" type="text" autocomplete="off" class="el-input__inner" 
                                    v-mask="{'alias': 'numeric', 'groupSeparator': '\'', 'autoGroup': true, 'digits': 2, 'digitsOptional': false, 'prefix': '', 'placeholder': '0'}" :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)">
                                </div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="21" :sm="8" :md="8" :lg="8" :xl="8">
                        <el-form-item :label="$t('Categories')" :prop="'additions.'+i+'.case_category_id'" :rules="[{ required: true, message: $t('This field is required'), trigger: ['blur','change']}]">
                            <el-select v-model="formData.additions[i].case_category_id" :placeholder="$t('Categories')" filterable :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)">
                                <el-option v-for="(item,id) in caseCategories.data" :label="item" :key="id" :value="parseInt(id)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="3" :sm="1" :md="1" :lg="1" :xl="1">
                        <el-form-item>
                            <el-button v-if="formData.additions.length > 1" size="mini" type="danger" @click="removeRow(i)" icon="el-icon-close" circle :disabled="(formData.edit ? ($store.state.config.user.role_slug == 'main-admin' && formData.status !== 'Pending')? true : false : false)"></el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="!formData.edit">
                <h3>{{ $t('Confirmation') }}:</h3>
                <el-form-item prop="confirmation">
                    <el-checkbox class="terms" label="yes" v-model="formData.confirmation" @change="checkvalidate()">
                        {{ $t('Hereby, the department confirms, in agreement with the legal representative, the correctness and release of this data in connection with the sponsorship.') }}
                    </el-checkbox>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item>
                    <el-button type="primary" @click="submitForm('formData')">{{ (formData.edit? $t('Update'):$t('Save')) }}</el-button>
                    <el-button type="cancel" @click="handleClose">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-col>
            <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
        </el-form>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            dialogFormVisible: Boolean,
            rowData: Object,
            fachstellenTypes: Object,
            fachstellen_slug: String,
            patenkinderList: Object,
            fachstellenList: Object,
            organization_slug: String,
            club_slug: String
        },
        data() {
            return {
                formData: {
                    patenkinder_slug: null,
                    payment_slip: [],
                    payment_slip_doc : [],
                    removed_payment_slip_doc: []
                },
                fileUpload: {
                    showFileList: true,
                    isDisabled: false,
                    fileNotChanged: true,
                },
                formDataWithFile: {},
                fields: {
                    reason: null,
                    cost: null,
                    case_category_id: null
                },
                caseCategories: {},
                filterData: {
                    patenkinderList: {},
                    fachstellenList: {},
                },
                rules: {
                    case_title: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    description: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    expected_amount: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }, {
                        type: "number",
                        message: this.$t('Please enter number'),
                        trigger: "blur"
                    }],
                    fachstellen_type: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "change"
                    }],
                    fachstellen_slug: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "change"
                    }],
                    patenkinder_slug: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "change"
                    }],
                    confirmation: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "change"
                    }],
                }
            };
        },
        methods: {
            checkvalidate(){
                if(!this.formData.confirmation){
                    this.formData.confirmation = null;
                }
            },
            handleCreate() {
                this.formData.additions.push(Object.assign({}, this.fields));
            },
            removeRow(i) {
                let rows = this.formData.additions;
                rows = rows.filter(function (item, key) {
                    return key !== i;
                });
                this.formData.additions = rows;
            },
            getAllFachstellen() {
                request({
                    url: "get-all-fachstellen",
                    method: "get",
                    params: {
                        fachstellen_type: this.formData.fachstellen_type,
                        organization_slug: this.organization_slug,
                        club_slug: this.club_slug
                    }
                }).then(response => {
                    this.formData.fachstellen_slug = null;
                    this.filterData.fachstellenList = response.data;
                });
            },
            getAllPatenkinder() {
                request({
                    url: "get-all-patenkinder",
                    method: "get",
                    params: {
                        fachstellen_slug: this.formData.fachstellen_slug,
                        organization_slug: this.organization_slug
                    }
                }).then(response => {
                    this.formData.patenkinder_slug = null;
                    this.filterData.patenkinderList = response.data;
                });
            },
            getCaseCategories() {
                request({
                    url: "get-case-categories",
                    method: "get"
                }).then(response => {
                    this.caseCategories = response.data;
                });
            },
            handleOpen() {
                this.formData = Object.assign({}, this.rowData);
                this.getCaseCategories();
                this.$nextTick(() => {
                    this.$refs['formData'].clearValidate();
                });
                if (!this.fachstellenList) {
                    this.getAllFachstellen();
                } else {
                    this.filterData.fachstellenList = this.fachstellenList;
                }
                if (!this.patenkinderList) {
                    this.getAllPatenkinder();
                } else {
                    this.filterData.patenkinderList = this.patenkinderList;
                }
            },
            handleClose() {
                this.$emit('popup', false);
                this.$refs['formData'].resetFields();
                this.handleRemove();
                this.clearFiles();
                this.fileUpload.fileNotChanged = true;
            },
            updateData(row) {   // row is FormData
                return request({
                        url: "patenkinder-cases/" + row.get('id'), // FormData's default method .get()
                        method: "POST",
                        data: row
                    })
                    .then(response => {
                        this.handleClose();
                        this.$emit('popupupdate', response.data.data);
                        this.$notify({
                            title: this.$t('Success'),
                            message: response.data.message,
                            type: "success",
                            offset: 50
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            title: this.$t('Error'),
                            message: error.response.data.message,
                            type: "error",
                            offset: 50
                        });
                    });
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.formDataWithFile = new FormData();
                        const tempFormData = this.formData;
                        for(let data in tempFormData) {
                            if (tempFormData[data] === 'null' || tempFormData[data] === null) {
                                this.formDataWithFile.append(data, '');
                            } else {
                                if(data === 'additions') {
                                    const tempArray = tempFormData[data];
                                    for (let addition in tempArray) {
                                        this.formDataWithFile.append('additions[' +addition +'][reason]', tempArray[addition].reason);  // statically passing array data as key value pair, since direct array can't be passed through 'FormData'.
                                        this.formDataWithFile.append('additions[' +addition +'][cost]', tempArray[addition].cost);
                                        this.formDataWithFile.append('additions[' +addition +'][case_category_id]', tempArray[addition].case_category_id);
                                    }
                                } else {
                                    this.formDataWithFile.append(data, tempFormData[data]);
                                }
                                // !this.formData.edit
                                if(data === 'payment_slip') {
                                    for ( var i = 0; i < this.formData.payment_slip.length; i++ ) {
                                        let file = this.formData.payment_slip[i];
                                        this.formDataWithFile.append('files[' + i + ']', file);
                                    }
                                }
                            }
                        }
                        if (this.formData.edit) {
                            // const paySlip = this.formDataWithFile.get('payment_slip');
                            // if (typeof(paySlip) === 'string' || paySlip === '') {
                            //     this.formDataWithFile.delete('payment_slip');
                            // }
                            // if (paySlip === ''  && this.rowData.payment_slip !== '') {
                            //     this.formDataWithFile.append('payment_slip_delete', 1);
                            // }
                            this.formDataWithFile.append('_method', 'PATCH');
                            return this.updateData(this.formDataWithFile);
                        }
                        request({
                                url: "patenkinder-cases",
                                method: "post",
                                data: this.formDataWithFile
                            })
                            .then(response => {
                                this.handleClose();
                                this.$emit('popupsave', false);
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: response.data.message,
                                    type: "success",
                                    offset: 50
                                });
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                            });
                    }
                });
            },
            handleChange(file, fileList) {
                if (this.beforeUpload(file.raw)) {
                    // if (!this.formData.edit) {
                        if(fileList) {
                            this.formData.payment_slip = fileList.map(file => {
                                return file.raw;
                            });
                        }
                    // }
                    // this.fileUpload.isDisabled = false;
                    // this.fileUpload.fileNotChanged = false;
                } else {
                    this.$refs.elFileUpload.clearFiles();
                }
            },
            beforeUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error(this.$t('File size should not exceed to 2MB'));
                }
                return isLt2M;
            },
            handleRemove(file, fileList) {
                // this.fileUpload.isDisabled = false;
                // if (!this.formData.edit) {
                    if(fileList) {
                        this.formData.payment_slip = fileList.map(file => {
                            return file.raw;
                        });
                    }
                // }
                // this.$refs.elFileUpload.clearFiles();
            },
            deleteUploadedFile(id) {
                request({
                    url: "remove/patenkinder-cases/image",
                    method: "delete",
                    data: {
                        docId : id,
                        patenkinderId : this.formData.id
                    }
                })
                .then(response => {
                    this.$notify({
                        title: this.$t('Success'),
                        message: response.data.message,
                        type: "success",
                        offset: 50
                    });
                    this.formData = response.data.data;
                    this.formData.payment_slip_doc = response.data.data.payment_slip_doc;
                })
                .catch(error => {
                    this.$notify({
                        title: this.$t('Error'),
                        message: error.response.data.message,
                        type: "error",
                        offset: 50
                    });
                });
                // this.handleRemove();
            },
            removeUploadedFile(index) {
                this.formData.removed_payment_slip_doc.push(
                    this.formData.payment_slip_doc[index].id
                );
                this.formData.payment_slip_doc.splice(index, 1);
            },
            clearFiles() {
                this.$refs.elFileUpload.clearFiles();
            }
        },
    }

</script>
<style lang="scss">
    .terms span.el-checkbox__label {
        width: 90%;
        vertical-align: top;
        text-transform: none;
    }
    .el-form-item__label {
        text-transform :none !important
    }
    .el-form-item__content {
         word-break: break-word !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Layout/Cases/Form.vue